import { RouteName } from "../RouteNames";

export const petitionsRoutes = {
  name: RouteName.PetitionsRoot,
  path: "petitions",

  meta: {
    permission_level: "SOCIETAL",
  },
  children: [
    {
      name: RouteName.Petitions,
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/PetitionsView.vue"),
    },
    {
      name: "Pétitions - Follawed",
      path: "follawed",
      component: () =>
        import("@follaw-fr/views/side_menu_views/PetitionsView.vue"),
    },
    {
      name: "Zoom petitions",
      path: ":id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/PetitionsZoomView.vue"),
    },
  ],
};
